// 品牌：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 品牌界面
export const ui = Object.freeze({
  "pcBrand.back": "返回",
  "pcBrand.unknown": "未知",
  "pcBrand.uncategorized": "未分类",
  "pcBrand.claimBrand": "认领品牌",
  "pcBrand.brandManagement": "品牌管理",
  "pcBrand.brandIntroduction": "品牌简介",
  "pcBrand.noBrandIntroduction": "暂无品牌简介",
  "pcBrand.companyIntroduction": "企业介绍",
  "pcBrand.noCompanyIntroduction": "暂无企业介绍",
  "pcBrand.openProductData": "进入产品数据",
  "pcBrand.productImage": "产品图片",
  "pcBrand.sold": "已售:",
  "pcBrand.noProductData": "暂无产品数据",
  "pcBrand.relatedCompanies": "关联企业",
  "pcBrand.brandOwner": "自有品牌",
  "pcBrand.distributor": "代理商",
  "pcBrand.trader": "贸易商",
  "pcBrand.active": "有效",
  "pcBrand.disabled": "禁用",
  "pcBrand.unknownType": "未知类型",
  "pcBrand.visitCompany": "进入公司主页",
  "pcBrand.noRelatedCompanies": "暂无关联企业",
  "pcBrand.noRelatedCompaniesOfThisType": "暂无该类型关联企业",
  "pcBrand.relatedProductFamilies": "关联商品系列",
  "pcBrand.value1Model": "1 个型号",
  "pcBrand.relatedOrders": "关联订单",
  "pcBrand.orders": "订单数",
  "pcBrand.tradedQuantity": "成交数量",
  "pcBrand.tradeValue": "成交金额",
  "pcBrand.tradingRegions": "成交地区",
  "pcBrand.time": "时间",
  "pcBrand.tradedModel": "成交型号",
  "pcBrand.product": "产品",
  "pcBrand.region": "地区",
  "pcBrand.quantity": "数量",
  "pcBrand.transactionValue": "交易额",
  "pcBrand.createdAt": "创建时间",
  "pcBrand.brandStrengths": "品牌优势",
  "pcBrand.leadingTechnology": "技术领先",
  "pcBrand.industryLeadingRDCapabilitiesAndPatents": "拥有行业领先的研发技术和专利",
  "pcBrand.qualityAssurance": "品质保证",
  "pcBrand.rigorousQualityControlsToEnsureProductQuality":
    "严格的质量控制体系，确保产品品质",
  "pcBrand.marketLeadership": "市场领先",
  "pcBrand.aStrongMarketShareInTheIndustry": "在行业内拥有较高的市场份额",
  "pcBrand.comprehensiveService": "完善服务",
  "pcBrand.comprehensiveTechnicalSupportAndAfterSalesService": "提供全方位的技术支持和售后服务",
  "pcBrand.companyNews": "公司动态",
  "pcBrand.partners": "合作伙伴",
  "pcBrand.relatedBrands": "相关品牌",
  "pcBrand.more": "更多 ▼",
  "pcBrand.collapse": "收起 ▲",
  "pcBrand.beijing0Shanghai0Guangzhou0Shenzhen0":
    "北京0家 | 上海0家 | 广州0家 | 深圳0家",
  "pcBrand.applications": "应用领域",
  "pcBrand.trademarkRegistrationCertificates": "商标注册证书",
  "pcBrand.companyName": "企业名称",
  "pcBrand.enterCompanyName": "请输入企业名称",
  "pcBrand.companyType": "企业类型",
  "pcBrand.trademarkCertificate": "商标证书",
  "pcBrand.distributorAuthorizationCertificate": "代理证书",
  "pcBrand.uploadTrademarkCertificate": "上传商标证书",
  "pcBrand.uploadAuthorizationCertificate": "上传代理证书",
  "pcBrand.cancel": "取消",
  "pcBrand.confirm": "确认",
  "pcBrand.companyNameIsRequired": "企业名称不能为空",
  "pcBrand.selectCompanyType": "请选择企业类型",
  "pcBrand.trademarkNumber": "商标编号",
  "pcBrand.headquarters": "总部",
  "pcBrand.productLines": "产品线",
  "pcBrand.authorizedRegions": "授权区域",
  "pcBrand.authorizationPeriod": "授权期限",
  "pcBrand.mainModels": "主营型号",
  "pcBrand.monthlySupplyCapacity": "月供能力",
  "pcBrand.china": "中国",
  "pcBrand.shenzhen": "深圳",
  "pcBrand.eastChina": "华东区",
  "pcBrand.southChina": "华南区",
  "pcBrand.shanghaiJiangsuZhejiangAnhui": "上海、江苏、浙江、安徽",
  "pcBrand.microcontrollersPowerManagementSensorsConnectivityChips":
    "微控制器、电源管理、传感器、连接芯片",
  "pcBrand.value20260101To20261231": "2026-01-01 至 2026-12-31",
  "pcBrand.brandClaimedSuccessfully": "认领成功",
  "pcBrand.brandIdIsRequired": "品牌ID不能为空",
  "pcBrand.couldNotLoadBrandDetails": "获取品牌详情失败",
  "pcBrand.brandInformation": "品牌信息",
  "pcBrand.brandName": "品牌名称",
  "pcBrand.enterTheChineseBrandName": "请输入品牌中文名称",
  "pcBrand.selectBrand": "选择品牌",
  "pcBrand.englishName": "英文名称",
  "pcBrand.enterTheEnglishBrandName": "请输入品牌英文名称",
  "pcBrand.brandRegion": "品牌地区",
  "pcBrand.selectBrandRegion": "请选择品牌地区",
  "pcBrand.brandCategory": "品牌分类",
  "pcBrand.selectBrandCategory": "请选择品牌分类",
  "pcBrand.yearFounded": "成立年份",
  "pcBrand.enterBrandIntroduction": "请输入品牌简介",
  "pcBrand.enterCompanyIntroduction": "请输入企业介绍",
  "pcBrand.smartSecurity": "智能安防",
  "pcBrand.homeAppliances": "家用电器",
  "pcBrand.smartIot": "智能物联",
  "pcBrand.medicalElectronics": "医疗电子",
  "pcBrand.communicationsNetworks": "通讯网络",
  "pcBrand.energyControl": "能源控制",
  "pcBrand.consumerElectronics": "消费电子",
  "pcBrand.industrialControl": "工业控制",
  "pcBrand.automotiveElectronics": "汽车电子",
  "pcBrand.brandLogo": "品牌Logo",
  "pcBrand.uploadLogo": "上传Logo",
  "pcBrand.contactInformation": "联系信息",
  "pcBrand.privacyProtection": "隐私保护",
  "pcBrand.contact": "联系人",
  "pcBrand.enterContactName": "请输入联系人姓名",
  "pcBrand.contactPhone": "联系电话",
  "pcBrand.enterContactPhone": "请输入联系电话",
  "pcBrand.email": "电子邮箱",
  "pcBrand.enterEmailAddress": "请输入电子邮箱",
  "pcBrand.reset": "重置",
  "pcBrand.submitApplication": "提交申请",
  "pcBrand.brandNameIsRequired": "品牌名称不能为空",
  "pcBrand.brandRegionIsRequired": "品牌地区不能为空",
  "pcBrand.brandCategoryIsRequired": "品牌分类不能为空",
  "pcBrand.yearFoundedIsRequired": "创建年份不能为空",
  "pcBrand.submittedSuccessfully": "提交成功",
  "pcBrand.foundedInYear": "成立于{year}年",
  "pcBrand.productsCount": "产品列表（{count}）",
  "pcBrand.expandCountMore": "展开（{count}条）▼",
  "pcBrand.moreCount": "更多（{count}个）▼",
  "pcBrand.countFamilies": "{count} 个系列",
  "pcBrand.countTrades": "{count} 笔成交",
  "pcBrand.shownTotalCompanies": "{shown} / {total} 家企业",
  "pcBrand.uploadType": "请上传{type}",
  "pcBrand.brandLaunchesNewProducts": "{brand}发布最新产品",
  "pcBrand.brandLaunchedNewProductsTodayBringingInnovativeSolutionsToTheMarket":
    "{brand}今日发布最新产品，为市场带来创新解决方案。",
  "pcBrand.brandAnnouncesStrategicPartnerships": "{brand}宣布战略合作伙伴关系",
  "pcBrand.brandHasFormedStrategicPartnershipsWithCompaniesToAdvanceTheIndustry":
    "{brand}与多家企业建立战略合作伙伴关系，共同推动行业发展。",
  "pcBrand.brandReportsGrowthIn2025": "{brand}2025年业绩增长",
  "pcBrand.brandGrewIn2025AndExpandedItsMarketShare":
    "{brand}2025年业绩持续增长，市场份额持续扩大。",
  "pcBrand.chinaMasterDistributor": "中国区总代理",
  "pcBrand.eastChinaDistributor": "华东区代理",
  "pcBrand.southChinaDistributor": "华南区代理",
  "pcBrand.nationwideTrader": "全国贸易商",
  "pcBrand.regionalTrader": "区域贸易商",
  "pcBrand.authorizedTrader": "授权贸易商",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const metadataFollowup = Object.freeze({
  "pcBrand.categoryVaristorGdt": "压敏电阻与气体放电管",
  "pcBrand.categoryDiodes": "二极管",
  "pcBrand.categoryTransistors": "三极管",
  "pcBrand.categoryResistors": "电阻",
  "pcBrand.categoryCapacitors": "电容",
  "pcBrand.categoryInductors": "电感",
  "pcBrand.regionUnitedKingdom": "英国",
  "pcBrand.regionGermany": "德国",
  "pcBrand.regionFrance": "法国",
  "pcBrand.regionSingapore": "新加坡",
  "pcBrand.regionHongKong": "中国香港",
});

export const messages = Object.freeze({
  ...metadataFollowup, ...ui });

// 已登记品牌显示别名
export const brandNames = Object.freeze({
  镁光: "镁光",
  美光: "美光",
  三星: "三星",
  现代: "现代",
  英特尔: "英特尔",
  海力士: "海力士",
  金士顿: "金士顿",
  兆易创新: "兆易创新",
  英伟达: "英伟达",
  长江存储: "长江存储",
  长鑫: "长鑫",
  广达: "广达",
  摩尔线程: "摩尔线程",
  时创意: "时创意",
  "闪迪/SANDISK": "闪迪/SANDISK",
  南亚: "南亚",
  紫光国芯: "紫光国芯",
  安世: "安世",
  ST意法半导体: "ST意法半导体",
  TI德州仪器: "TI德州仪器",
  "TOSHIBA/东芝": "TOSHIBA/东芝",
  "onsemi/安森美": "onsemi/安森美",
  "Yeestor/得一微": "Yeestor/得一微",
  "AMD/超微": "AMD/超微",
  "OADATA/威刚": "OADATA/威刚",
  "江波龙/FORESEE": "江波龙/FORESEE",
  "高通/GENITOP": "高通/GENITOP",
  "富士通/FUJITSU": "富士通/FUJITSU",
  "芯邦/Chipsbank": "芯邦/Chipsbank",
  "上海贝岭/BL": "上海贝岭/BL",
  "深圳汉芯/HGC": "深圳汉芯/HGC",
  "宏旺/DICMAX": "宏旺/DICMAX",
  "海天芯/CHTCSEMI": "海天芯/CHTCSEMI",
  "英飞凌/Infineon": "英飞凌/Infineon",
  华虹挚芯: "华虹挚芯",
  "夏普/OSHARP": "夏普/OSHARP",
  "澜智/Zetta": "澜智/Zetta",
  "华邦/Winbond": "华邦/Winbond",
  "伍尔特/OWurth": "伍尔特/OWurth",
  "恒烁/Zbit": "恒烁/Zbit",
  "芯伯乐/XBLW": "芯伯乐/XBLW",
  "芯天下/XTX": "芯天下/XTX",
  "唯创知音/OWT": "唯创知音/OWT",
  "威世/CVISHAY": "威世/CVISHAY",
  "精工/Seiko": "精工/Seiko",
  "森萨塔/Sensata": "森萨塔/Sensata",
  "上海矽朋/Siproin": "上海矽朋/Siproin",
  "三友/SANYOU": "三友/SANYOU",
  "罗姆/OROHM": "罗姆/OROHM",
  "晶存/Rayson": "晶存/Rayson",
  "瑞萨/RENESAS": "瑞萨/RENESAS",
  "恩智浦/ONXP": "恩智浦/ONXP",
  "迪浦/PUOLOP": "迪浦/PUOLOP",
  "普冉/PUYA": "普冉/PUYA",
  "米客方德/MK": "米客方德/MK",
  "灵星芯微/OLX": "灵星芯微/OLX",
  "来扬/Lyontek": "来扬/Lyontek",
  "力积电子/Zentel": "力积电子/Zentel",
});

// 已登记分类显示别名
export const categoryNames = Object.freeze({
  IC存储器: "IC存储器",
  DDR颗粒: "DDR颗粒",
  wafer晶圆: "wafer晶圆",
  FLASH颗粒: "FLASH颗粒",
  服务器: "服务器",
  国产服务器: "国产服务器",
  进口服务器: "进口服务器",
  电位器: "电位器",
  保险丝: "保险丝",
  服务器条子: "服务器条子",
  内存条: "内存条",
  "Nand Flash BGA颗粒": "Nand Flash BGA颗粒",
});

// 已登记地区显示别名
export const regionNames = Object.freeze({
  韩国: "韩国",
  美国: "美国",
  中国: "中国",
  台湾: "台湾",
  欧洲: "欧洲",
  日本: "日本",
});
